import React from 'react';
import './customerOrders.scss';

import customerOrderDetail from './customerOrderDetail.js';

//import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { createStore } from 'devextreme-aspnet-data';

import { SimpleItem, GroupItem, Item, TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';

import { useState, useEffect, useCallback } from "react";
//import Button from 'devextreme-react/button';
import {Button as ToolbarButton} from 'devextreme-react/button';
import {Popup} from 'devextreme-react/popup';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { CheckBox } from 'devextreme-react/check-box';
import { formatNumber } from 'devextreme/localization';

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import {handleAuthError, useCheckUserAuthentication,fetchLookup, IsRole_Designer} from '../../globals';
//import { useAuth } from  '../../contexts/auth'; 

const serviceUrlX = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ExcelService'
const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineCliente'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineClienteRiepilogo'
const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_OrdiniClienti'
const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineClienteSoggetto'
//const serviceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineClienteRata'
const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'


const editorOptions = { readonly: true, format: '###,##0.00'};
const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};

const debug = process.env.ENTITY_DEBUG;

export const numeriRata =  [{id:1,desc: '1'},{id:2,desc: '2'},{id:3,desc: '3'},{id:4,desc: '4'},{id:5,desc: '5'},{id:6,desc: '6'}];

export default function CustomerOrders(props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;

  const initYear = isInProject? 0:new Date().getFullYear();
  const initIntermediario = isInProject? 0:210;

  var cusOrdDataGridRef = React.createRef();

  const isDesigner =IsRole_Designer();
  //console.log('IsDesigner: ' + isDesigner);

  const [stati, setStati] = useState({});
  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});
  const [valute, setValute] = useState({});
  const [currentId, setCurrentId] = useState(0);
  const [currentDocNo, setCurrentDocNo] = useState();
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isGoToProject, setIsGoToProject] = useState(false);
  const [isClosed, setIsClosed] = useState(true);

  const [currentPrj, setCurrentPrj] = useState(0);
  const [currentPrjNo, setCurrentPrjNo] = useState();
  const [isPrjSelected, setIsPrjSelected] = useState(false);

  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(initYear);
  const [clienteFilter, setClienteFilter] = useState();
  const [statoFilter, setStatoFilter] = useState();
  const [isStorico, setIsStorico] = useState(false);
  const [intermediarioFilter, setIntermediarioFilter] = useState(initIntermediario);
  const [isEditable, setIsEditable] = useState(true);

  const [isPopupVisible2, setPopupVisibility2] = useState(false);
  const togglePopup2 = () => {
    setPopupVisibility2(!isPopupVisible2);
  };

  const allowedPageSizes = [5, 10, 20];

  const user = useCheckUserAuthentication();

  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    cliente: clienteFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    commessa: projectId,
  };

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl3 + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
    ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',

    errorHandler: (error) => {
      handleAuthError(error);
    }
    
  });

  const remoteDataSource2 = createStore({

    key: 'id',
    loadUrl: serviceUrl2 + '/FindByOrdineCliente/' + currentId,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
    
    errorHandler: (error) => {
      handleAuthError(error);
    }

  });

  const remoteDataSource4 = createStore({
    key: 'id',
    loadUrl: serviceUrl4 + '/FindByOrdineCliente/' + currentId,
    updateUrl:serviceUrl4 + '/UpdateAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },

    errorHandler: (error) => {
      handleAuthError(error);
    }
    
  });

  const remoteDataSource6 = createStore({
    key: 'id',
    loadUrl: serviceUrl6 + '/GetAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },

    errorHandler: (error) => {
      handleAuthError(error);
    }

  });

  function onEditingStart(e) {
    //console.log("EDITING: " + e.key);
    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA
    setCurrentId(e.key);

  }

  const onEditorPreparing = (e) => {
    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "destinazioneId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "intermediarioId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    //può approvare solo admin
    // if(e.dataField === "statoId" && e.parentType ==="dataRow"){
    //   if (!isAdmin && e.row.data.statoId === 7) 
    //     e.editorOptions.disabled = true;
    // }
    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      if (!(e.row.data.statoId === 1) || e.row.data.statoId === null)
        setIsEditable(false)
      else
        setIsEditable(true)
    }

    if(e.dataField === "numeroDoc" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 6) && e.row.data.statoId != null;
    }

  }  

  useEffect(() => {

    const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineStato';
    var newUrl =  newServiceUrl + "/GetAction";

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl2 =  newServiceUrl2 + "/GetClienti";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
    var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

    const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
    var newUrl4 =  newServiceUrl4 + "/GetAction";

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
    var newUrl6 =  newServiceUrl6 + "/GetAction";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
    var newUrl8 =  newServiceUrl8 + "/GetAction";

    const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniOrdiniClienti';
    var newUrl9 =  newServiceUrl9 + "/GetAction";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const json2 = await fetchLookup(newUrl2,requestOptions);
        if (json2) {
          setClienti(json2);
        }
        
        // const response2 = await fetch(newUrl2,requestOptions);
        // const json2 = await response2.json();
        // if (debug === 1)
        //   console.log(json2);
        // setClienti(json2);

        const json3 = await fetchLookup(newUrl3,requestOptions);
        if (json3) {
          setCollaboratori(json3);
        }

        // const response3 = await fetch(newUrl3,requestOptions);
        // const json3 = await response3.json();
        // if (debug === 1)
        //   console.log(json3);
        // setCollaboratori(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        if (debug === 1)
          console.log(json4);
        setValute(json4);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        if (debug === 1)
          console.log(json6);
        setCondizioniPagam(json6);

        // const response7 = await fetch(newUrl7,requestOptions);
        // const json7 = await response7.json();
        // if (debug === 1)
        //   console.log(json7);
        // setIntermediari(json7);

        const json7 = await fetchLookup(newUrl7,requestOptions);
        if (json7) {
          setIntermediari(json7);
        }

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
         console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
  }, [user?.token]); // Aggiorna se il token cambia

  function refreshDataGrid() {
    cusOrdDataGridRef.instance().refresh();
  }

  function importa() {
    let result = confirm("<i>Procedere con l'importazione?</i>", "Importa ordini");
    result.then((dialogResult) => {
      if  (dialogResult) {
        importFile();
      }  
    });
  }

  function importFile(t) {
  
    const url =  serviceUrlX + "/ImportCustomerOrder";

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;             
      })
      .then(data => {
        //notify(data.message, data.success ? 'success' : 'error', 5000);
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 5000);         
        }, 100);
        cusOrdDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); });

  }; 


  function printOrder(id) {

    const url =  serviceUrl3 + "/CreateOrdineClientePDF/" + id;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.blob();        
        //Global.CheckResponseAuth(response);
      })
      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var slug = "Ordine";

        a.download = slug + ".pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 5000); });

  };  


  function print(e) {
    printOrder(currentRow);
    notify("Stampa ordine: " + currentDocNo);
  }

  const copia= (idOrdine) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineCliente/NewVersion/' + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
    }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        cusOrdDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const duplica= (idOrdine) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineCliente/Duplicate/' + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        cusOrdDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function newVersion(e) {
    let result = confirm("<i>Procedere con la creazione di una nuova revisione?</i>", "Nuova revisione");
    result.then((dialogResult) => {
      if  (dialogResult) {
        copia(currentRow);
      }  
    });
  }

  function duplicate(e) {
    let result = confirm("<i>Procedere con la duplicazione dell'ordine?</i>", "Duplicazione Ordine");
    result.then((dialogResult) => {
      if  (dialogResult) {
        duplica(currentRow);
      }  
    });
  }

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      setIsRowSelected(true);
       if(data.statoId === 3)
        setIsClosed(true);
      else
        setIsClosed(false);

      console.log("SELECTED: " + data.id);
      //setCurrentId(e.currentSelectedRowKeys);

    } else{
      setIsRowSelected(false);
      setIsClosed(true);
    }

    if (data != null && data.statoId > 0)
      setIsGoToProject(true);
    else
      setIsGoToProject(false);
  }

  function customizeText(data) {
    return `Ordini: ${data.value}`;
  }

  function customizeData(data) {
    return `${formatNumber(data.value, '###,##0.00')}`;
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuovo Ordine'
  };

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };
  
  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };

  const selectBoxOptions3 = {
    width: 210,
    items: clienti,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Clienti>",
    showClearButton:true,
    searchEnabled:true,
    onValueChanged: (args) => {
      setClienteFilter(args.value);
    },
    value: clienteFilter,
  };

  const selectBoxOptions4 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  

  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
       { if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
          else if (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
          else if (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
          else if (e.data.statoId === 4)
            e.cellElement.style.cssText = "color: white; background-color: red";
          else if (e.data.statoId === 5)
            e.cellElement.style.cssText = "color: white; background-color: #DDBBFF";
          else if (e.data.statoId === 6)
          e.cellElement.style.cssText = "color: white; background-color: #558ea7";
        }
    }
  }

   
  
  const hideEditButton = useCallback((e) => {
    return e.row.data.statoId !== 3 && e.row.data.statoId !== 2;
  }, []);


  const aggiungiACommessa= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/AddCustomerOrderToProject/' + currentPrj + '/' +currentRow;

    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function addToProject(e) {
    let result = confirm("<i>Aggiungere il documento selezionato alla Commessa " + currentPrjNo + "?</i>", "Aggiungi a Commessa");
      result.then((dialogResult) => {
        if  (dialogResult) {
          aggiungiACommessa();
          setPopupVisibility2(false);
        }  
      });
  }




  function updateMovs() {    
    let result = confirm("<i>Aggiornare gli Incassi dell'ordine selezionato'?</i>", "Aggiorna Incassi");
    result.then((dialogResult) => {
    if (dialogResult) 
      aggiornaMovimenti(currentRow);   
    });
  };

  function onCheckValueChanged(e)  {
    setIsStorico(e.value);
  };

  const aggiornaMovimenti= (idOrdine) => {
      
    var path = "";
    path = '/api/OrdineCliente/UpdateProceedsMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const editIconClick = (e) => {

    // this.setState({ data: updatedData }, () => {
    //   e.component.editRow(e.row.rowIndex);
    // });

    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA
    //setCurrentId(e.row.data.id);
    //e.component.editRow(e.row.rowIndex);
  };


  function cancelAddToProject()  {
    setPopupVisibility2(false);
    setCurrentPrj(0);
    setCurrentPrjNo(0);
    setIsPrjSelected(false);
  };

  function onRowSelectionChangedPrj({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentPrj(data.id);
      setCurrentPrjNo(data.codice);
      setIsPrjSelected(true);
    } else{
      setCurrentPrj(0);
      setIsPrjSelected(false);
    }
  }

  const renderContent2 = () =>  {
    return (
      <div>

  { isPrjSelected &&
    <p>Aggiungi il documento selezionato alla Commessa <b>{currentPrjNo}</b></p>
  }
     
      <DataGrid id="grid-popup2"
        className={'dx-card wide-card'}
        dataSource={remoteDataSource6}
        showBorders={true}

        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        onSelectionChanged={onRowSelectionChangedPrj}
      >
        <Pager
            showPageSizeSelector={false}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
        />
        <Selection mode="single" />
        <Paging defaultPageSize={10} />
       
        <Toolbar>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='todo'
              hint='Conferma'
              disabled={!isPrjSelected}
              onClick={addToProject} 
            />
          </Item>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Annulla'
              onClick={cancelAddToProject} 
            />
          </Item>    
      
        </Toolbar>
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" caption="Codice" width={110}/>
        <Column dataField="nome" dataType="date" caption="Nome" />
        <Column dataField="clienteId" caption="Cliente" >
          <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
      </DataGrid>
      </div>            
    )
  }


  function onRowInserting(e) {
    e.data.createBy = user.name;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  return (
  <React.Fragment>
    { !isInProject &&  <h2 className={'content-block'}>Ordini Clienti</h2> }
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid id="grid-container"
          ref={ref => cusOrdDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}

          onSelectionChanged={onRowSelectionChanged}
          //onRowExpanded={onRowExpanded}
          onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          onCellPrepared={onCellPrepared}
          onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          dateSerializationFormat= {'yyyy-MM-dd'}
        >
         
         { !isInProject
            &&   
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='import'
                hint='Importa'
                onClick={importa} 
                visible={isDesigner}
              />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} 
              />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='copy'
                hint='Duplica'
                onClick={duplicate}
                disabled={!isRowSelected} />
            </Item>       
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='inserttable'
                hint='Nuova Revisione'
                onClick={newVersion}
                disabled={isClosed} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='hidepanel'
                hint='Aggiorna Incassi'
                onClick={updateMovs} 
                disabled={!isRowSelected}
                />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='print'
                hint='Stampa'
                onClick={print}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='columnchooser'
                hint='Aggiungi a Commessa'
                onClick={togglePopup2}
                disabled={!isGoToProject} />
            </Item>
            <Item location="after">
              <CheckBox  
                value={isStorico} onValueChanged={onCheckValueChanged}
                defaultValue={isStorico}
                text="  Storico   "
              >
              </CheckBox>
            </Item> 
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>

            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
          }

          <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
              column="numero"
              summaryType="count"
              customizeText={customizeText}
            />
            <TotalItem
              column="imponibile"
              summaryType="sum" 
              customizeText={customizeData}
            />
          </Summary>
          <Selection mode="single" />

          <Editing
            mode="popup"
            allowUpdating={true}
            allowAdding={!isInProject}
            allowDeleting={true}
            useIcons={true}
          >
          
          <Popup title="Ordine" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
                <Item dataField="numeroDoc" colSpan={2}/>
                <Item dataField="statoId"colSpan={2} isRequired= "true"/>
                <Item dataField="dataDoc"colSpan={2} isRequired= "true"/>
                <Item dataField="dataConsegna"colSpan={2}/>
                <Item dataField="oggetto"colSpan={4}/>
                
     
                <Item dataField="clienteId" colSpan={2} isRequired= "true"/>
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
                <Item dataField="riferimentoInternoId" colSpan={2} isRequired= "true"/>
                
                <Item dataField="riferimentoCliente"colSpan={2} />
                <Item dataField="commessaCliente"colSpan={2} />
                <Item dataField="numeroContratto"colSpan={2} />

              </Item> 

             
                <GroupItem caption="Riepilogo" colCount={4} colSpan={2} >
                  <TabbedItem colSpan={4}>
                    <TabPanelOptions deferRendering={false} />
                  
                    <Tab title="Vendita" colCount={3}>
                      <SimpleItem dataField="importoLordo" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="percSconto" />
                      <SimpleItem dataField="importoSconto" editorOptions={editorOptions}/>
                  
                      <SimpleItem dataField="imponibile" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="imposte" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="importoTotale" editorOptions={editorOptions} disabled={true}/>
                    </Tab>
                    <Tab title="Imposte" colCount={3}>
                      <DataGrid id="grid-subcontainer" dataSource={remoteDataSource2}>
                        <Column dataField="id" visible={false}/>
                        <Column dataField="codiceIva"width={80}/>
                        <Column dataField="aliquotaIva"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imponibile"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imposta"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                      </DataGrid>
                    </Tab> 
                    <Tab title="Soggetti" colCount={3}>
                    <DataGrid id="grid-subcontainer2"
                    dataSource={remoteDataSource4}
                    >
                      <Editing
                        mode="form" 
                        allowUpdating={isEditable}
                        useIcons={true}
                      >
                        <Form>
                          <Item dataField="nome"/>
                          <Item dataField="indirizzo"/>
                          <Item dataField="città"/>
                          <Item dataField="provincia"/>
                          <Item dataField="cap"/>
                          <Item dataField="nazione"/>
                          <Item dataField="piva"/>
                          <Item dataField="cf"/>
                          <Item dataField="codiceDestinatario"/>
                          <Item dataField="pec"/>
                        </Form>
                       </Editing>
                      <Column dataField="id" visible={false}/>
                      <Column dataField="tipoSoggettoId" caption="Tipo" width={120} >
                        <Lookup dataSource={tipiSoggetto} valueExpr="id" displayExpr="nome" />
                      </Column>
                      
                      <Column dataField="nome" width={200}/>
                      <Column dataField="indirizzo" width={200}/>
                      <Column dataField="città"/>
                      <Column dataField="provincia" width={80} visible={false}/>
                      <Column dataField="cap" width={80} visible={false} />
                      <Column dataField="nazione" visible={false}/>
                      <Column dataField="piva" width={120}/>
                      <Column dataField="cf" width={150}/>
                      <Column dataField="codiceDestinatario" width={120} caption="Cod. Dest." visible={false} />
                      <Column dataField="pec" width={120} visible={false}/>
                     
                    </DataGrid>
                  </Tab> 


                  </TabbedItem>
                </GroupItem>
            </Form>
          </Editing>
              

          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num" width={110}/>
          <Column dataField="numeroDoc" caption="Num" visible={false}/>
          <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data doc." />
          <Column dataField="dataConsegna" dataType="date" format= {'dd/MM/yyyy'} caption="Data Consegna"  visible={false}/>
          <Column dataField="clienteId" caption="Cliente" >
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="oggetto" caption="Oggetto" />
      
          <Column dataField="descrizione" caption="Descrizione" visible={false}/>
          <Column dataField="codiceCommessa" caption="Commessa" />

          <Column dataField="riferimentoCliente" caption="Rif. Ordine Cliente" visible={true}/>
          <Column dataField="commessaCliente" caption="Rif. Commessa Cliente" visible={true}/>
          <Column dataField="numeroContratto" caption="Num. Contratto"visible={true}/>

          <Column dataField="riferimentoInternoId" caption="Manager" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" width={240} visible={false}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="imponibile"  width={100} caption="Imponibile">
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoTotale"  width={100} caption="Totale">
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoLordo" visible={false} >
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="percSconto" visible={false} />
          <Column dataField="importoSconto" visible={false} />
          <Column dataField="importoScontato" visible={false} />
          <Column dataField="imposte" visible={false} />
          <Column dataField="statoId" caption="Stato" width={110}>
            <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="updateBy" visible={false}/>
          <Column dataField="createBy" visible={false}/>




          <Column type="buttons">
            <Button name="edit"  />
            <Button name="delete" visible={hideEditButton}/>
          </Column>

          <MasterDetail
            enabled={true}
            component={customerOrderDetail}
          />
        </DataGrid>

        <div>
          <Popup
            width={800}
            height={640} 
            showTitle={true}
            title="Seleziona Commessa"
            visible={isPopupVisible2}
            hideOnOutsideClick={true}
            onHiding={togglePopup2}
            contentRender={renderContent2}
          > 
          </Popup> 
        </div>

      </div>
    </div>
  </React.Fragment>
  )
};
